<footer style="padding-bottom:30px">
    <div class="align-center text-center py-md-^1 py-1">
        <a routerLink="/impressum">Imprint</a>
        <a routerLink="/privacy" class="ml-3">Privacy</a>
        <a routerLink="/terms-of-use" class="ml-3">Terms of Use</a>
    </div>
</footer>
